import React, { useEffect } from 'react';
import './Toast.css';

interface ToastAction {
  label: string;
  onClick: () => void;
}

interface ToastProps {
  message: string;
  type?: 'success' | 'error' | 'info';
  onClose: () => void;
  duration?: number;
  action?: ToastAction;
}

export function Toast({ message, type = 'info', onClose, duration = 5000, action }: ToastProps) {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, duration);

    return () => clearTimeout(timer);
  }, [onClose, duration]);

  const handleActionClick = () => {
    if (action) {
      action.onClick();
      onClose();
    }
  };

  return (
    <div className={`toast toast-${type}`}>
      <div className="toast-content">
        <span className="toast-message">{message}</span>
        {action && (
          <button onClick={handleActionClick} className="toast-action">
            {action.label}
          </button>
        )}
      </div>
      <button onClick={onClose} className="toast-close">×</button>
    </div>
  );
}
